var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-card",
    {
      staticClass: "mb-2",
      attrs: { "no-body": "", "border-variant": "light" },
    },
    [
      _c(
        "b-card-header",
        {
          staticClass: "p-0 border-light custom-header",
          attrs: { "header-tag": "header", role: "tab" },
        },
        [
          _c(
            "b-row",
            { staticClass: "mb-2" },
            [
              _c(
                "b-col",
                { staticClass: "col-auto" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "text-uppercase fs-14 fw-600",
                      attrs: {
                        variant: _vm.visible
                          ? "custom-green"
                          : "outline-secondary",
                      },
                      on: {
                        click: function ($event) {
                          _vm.displayed = !_vm.displayed
                        },
                      },
                    },
                    [
                      _vm._v(" " + _vm._s(_vm.title) + " "),
                      _c(
                        "span",
                        { staticClass: "float-right ml-2" },
                        [
                          _c("b-icon", {
                            attrs: {
                              icon: _vm.displayed
                                ? "chevron-up"
                                : "chevron-down",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm.supplementaryAgreement.status.code === "signed_by_both"
                    ? _c(
                        "b-button",
                        {
                          staticClass: "ml-2 download-pdf",
                          attrs: {
                            disabled: _vm.pdfLoading,
                            variant: "custom-green",
                            title:
                              "Нажмите, чтобы скачать дополнительное соглашение в формате PDF",
                          },
                          on: { click: _vm.downloadPDF },
                        },
                        [_c("b-icon-file-earmark-pdf")],
                        1
                      )
                    : _vm._e(),
                  _vm.supplementaryAgreement.supplier_signature ||
                  _vm.supplementaryAgreement.customer_signature
                    ? _c("signature-xml-info-button", {
                        staticClass: "ml-2",
                        attrs: {
                          title: `Электронная подпись к дополнительному соглашению №${_vm.supplementaryAgreement.number}`,
                          "supplier-signature":
                            _vm.supplementaryAgreement.supplier_signature,
                          "customer-signature":
                            _vm.supplementaryAgreement.customer_signature,
                          "allow-download-xml":
                            _vm.purchase.flags.is_participant,
                          filename: `supplementary_agreement_${_vm.supplementaryAgreement.number}_signature_info`,
                          mt: 0,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c("b-col", { staticClass: "my-auto" }, [
                _c("span", { staticClass: "fs-14 fw-600" }, [
                  _vm._v(_vm._s(_vm.supplementaryAgreement.status.title)),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-collapse",
        {
          attrs: {
            id: _vm.id,
            accordion: "supplementary-agreements-accordion",
            role: "tabpanel",
          },
          model: {
            value: _vm.displayed,
            callback: function ($$v) {
              _vm.displayed = $$v
            },
            expression: "displayed",
          },
        },
        [
          _c(
            "b-card-body",
            { staticClass: "py-0 px-2" },
            [
              _c("text-row-price", {
                attrs: {
                  "label-cols-lg": 4,
                  compact: "",
                  label:
                    "Стоимость контракта с учетом дополнительного соглашения",
                },
                model: {
                  value: _vm.supplementaryAgreement.price,
                  callback: function ($$v) {
                    _vm.$set(_vm.supplementaryAgreement, "price", $$v)
                  },
                  expression: "supplementaryAgreement.price",
                },
              }),
              _c("text-row-date", {
                attrs: {
                  "label-cols-lg": 4,
                  compact: "",
                  label: "Дата заключения дополнительного соглашения",
                },
                model: {
                  value: _vm.supplementaryAgreement.conclusion_date,
                  callback: function ($$v) {
                    _vm.$set(_vm.supplementaryAgreement, "conclusion_date", $$v)
                  },
                  expression: "supplementaryAgreement.conclusion_date",
                },
              }),
              _c("fl44-unknown-volume-supplementary-agreement-files-table", {
                attrs: {
                  "download-zip": _vm.downloadZip,
                  "supplementary-agreement": _vm.supplementaryAgreement,
                },
                scopedSlots: _vm._u([
                  {
                    key: "title",
                    fn: function () {
                      return [_vm._v(" Документы ")]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _vm.supplementaryAgreement
                .supplementary_agreement_disagreements &&
              _vm.supplementaryAgreement.supplementary_agreement_disagreements
                .length > 0
                ? _c("text-row-disagreement-table", {
                    attrs: {
                      disagreements:
                        _vm.supplementaryAgreement
                          .supplementary_agreement_disagreements,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "title",
                          fn: function () {
                            return [
                              _c(
                                "h5",
                                {
                                  staticClass:
                                    "grey-color mt-3 mb-1 main_text font-weight-bold",
                                },
                                [
                                  _vm._v(
                                    "Разногласия по дополнительному соглашению"
                                  ),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      2973213072
                    ),
                  })
                : _vm._e(),
              _c("text-row-proposal-specification-table", {
                attrs: {
                  "without-vat": _vm.purchase.supplier_proposal.without_vat,
                },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function () {
                      return [
                        _c(
                          "h5",
                          {
                            staticClass:
                              "grey-color ml-1 mb-1 main_text font-weight-bold",
                          },
                          [_vm._v("Спецификация контракта")]
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.purchase.supplier_proposal.deliverables,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.purchase.supplier_proposal,
                      "deliverables",
                      $$v
                    )
                  },
                  expression: "purchase.supplier_proposal.deliverables",
                },
              }),
              _vm.supplementaryAgreement.status.code === "signed_by_both" &&
              _vm.purchase.is_customer &&
              _vm.limitsRequired &&
              _vm.supplementaryAgreement.limits &&
              _vm.supplementaryAgreement.limits.length > 0
                ? [
                    _vm.isLimitsEdit
                      ? _c("limits-editable-table", {
                          attrs: {
                            "total-cost": _vm.supplementaryAgreement.price,
                            "limit-year":
                              _vm.purchase.purchase_terms.purchase_limit_year,
                            "order-type":
                              _vm.purchase.purchase_terms.order_type,
                            "is-data-sending": _vm.isDataSending,
                            "purchase-type": "fl44_unknown_volume",
                            "purchase-id": _vm.purchase.id,
                          },
                          on: { validate: _vm.limitsValidate },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "title",
                                fn: function () {
                                  return [
                                    _c(
                                      "h5",
                                      {
                                        staticClass:
                                          "grey-color ml-1 mt-3 mb-1 main_text font-weight-bold",
                                      },
                                      [_vm._v("Измените лимиты")]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "label-hint",
                                fn: function () {
                                  return [
                                    _vm._v(
                                      " Добавьте или измените лимиты. Необходимо полностью распределить цену дополнительного соглашения по соответствующим лимитам. "
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "label-total",
                                fn: function () {
                                  return [
                                    _vm._v(
                                      " Цена дополнительного соглашения, руб.: "
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "label-variance",
                                fn: function () {
                                  return [
                                    _vm._v(
                                      " Отклонение от цены дополнительного соглашения, руб.: "
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            20260220
                          ),
                          model: {
                            value: _vm.form.limits,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "limits", $$v)
                            },
                            expression: "form.limits",
                          },
                        })
                      : _c("limits-table", {
                          attrs: { items: _vm.supplementaryAgreement.limits },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "title",
                                fn: function () {
                                  return [
                                    _c(
                                      "h5",
                                      {
                                        staticClass:
                                          "grey-color ml-1 mb-1 main_text font-weight-bold",
                                      },
                                      [_vm._v("Лимиты по КБК")]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            4025625095
                          ),
                        }),
                    _vm.purchase.status.id === "contract:active" &&
                    _vm.purchase.contract.latest_supplementary_agreement_id ===
                      _vm.supplementaryAgreement.id
                      ? [
                          _vm.isLimitsEdit
                            ? [
                                _c(
                                  "b-overlay",
                                  {
                                    staticClass: "d-inline-block",
                                    attrs: {
                                      show: _vm.isDataSending,
                                      opacity: "0.6",
                                      rounded: "",
                                      "spinner-small": "",
                                      "spinner-variant": "primary",
                                    },
                                  },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        staticClass:
                                          "text-uppercase mt-1 mb-3 mr-3",
                                        attrs: {
                                          variant: "custom-outline-secondary",
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.isLimitsEdit = false
                                          },
                                        },
                                      },
                                      [_vm._v("Отмена")]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-overlay",
                                  {
                                    staticClass: "d-inline-block",
                                    attrs: {
                                      show: _vm.isDataSending,
                                      opacity: "0.6",
                                      rounded: "",
                                      "spinner-small": "",
                                      "spinner-variant": "primary",
                                    },
                                  },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        staticClass: "text-uppercase mt-1 mb-3",
                                        attrs: {
                                          variant: "custom-green",
                                          disabled: !_vm.isLimitsValid,
                                        },
                                        on: { click: _vm.updateLimits },
                                      },
                                      [_vm._v("Сохранить")]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            : [
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "text-uppercase mt-1 mb-3",
                                    attrs: { variant: "custom-green" },
                                    on: { click: _vm.editLimits },
                                  },
                                  [_vm._v("Изменить лимиты")]
                                ),
                              ],
                        ]
                      : _vm._e(),
                  ]
                : _vm._e(),
              _vm.supplementaryAgreement.status.code === "signed_by_both" &&
              _vm.purchase.is_customer &&
              _vm.purchase.flags.has_contract &&
              _vm.supplementaryAgreement.supplier_accounting
                ? _c("text-row-supplier-accounting", {
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "title",
                          fn: function () {
                            return [
                              _c(
                                "h5",
                                {
                                  staticClass:
                                    "grey-color ml-1 mt-3 mb-1 main_text font-weight-bold",
                                },
                                [_vm._v("Банковские реквизиты поставщика")]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      2488944890
                    ),
                    model: {
                      value: _vm.supplementaryAgreement.supplier_accounting,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.supplementaryAgreement,
                          "supplier_accounting",
                          $$v
                        )
                      },
                      expression: "supplementaryAgreement.supplier_accounting",
                    },
                  })
                : _vm._e(),
              _vm.purchase.contract.latest_supplementary_agreement_id ===
                _vm.supplementaryAgreement.id &&
              _vm.$store.getters.isLoggedIn &&
              _vm.purchase.is_supplier &&
              _vm.purchase.actions.supplier.supplementary_agreement !==
                "disallow"
                ? _c(
                    "private-fl44-unknown-volume-supplementary-agreement-supplier-block",
                    {
                      attrs: {
                        "supplementary-agreement": _vm.supplementaryAgreement,
                        purchase: _vm.purchase,
                      },
                      on: {
                        refresh: function ($event) {
                          return _vm.$emit("refresh")
                        },
                      },
                    }
                  )
                : _vm._e(),
              _vm.purchase.contract.latest_supplementary_agreement_id ===
                _vm.supplementaryAgreement.id &&
              _vm.$store.getters.isLoggedIn &&
              _vm.purchase.is_customer &&
              _vm.purchase.actions.customer.supplementary_agreement !==
                "disallow"
                ? _c(
                    "private-fl44-unknown-volume-supplementary-agreement-customer-block",
                    {
                      attrs: {
                        purchase: _vm.purchase,
                        "supplementary-agreement": _vm.supplementaryAgreement,
                      },
                      on: {
                        refresh: function ($event) {
                          return _vm.$emit("refresh", $event)
                        },
                      },
                    }
                  )
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }